angular.module('impactx.search').directive('ixAttributeSearch', function () {
    return {
        restrict: 'E',
        scope: {
            facetResults: "=",
            guidedFacetResult: "=",
            numberOfAttributes: "=",
            drillDownCallback: "&",
            useSearchFilterFactoryForDrilldown: "="
        },
        controller: function ($scope, SearchFilter, searchFilter) {
            $scope.exists = SearchFilter.existsDrillDown;
            $scope.toggleDrillDown = function (item) {
                SearchFilter.toggleDrillDown(item);
                if ($scope.useSearchFilterFactoryForDrilldown) {
                    searchFilter.toggleDrillDown(item);
                }
                $scope.drillDownCallback();
            }
        },
        templateUrl: 'modules/search/templates/attributesearch.html'
    }
});